import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Create Stakeholder',
      type: 'details',
      alias: 'create.stakeholder.modal',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'save.stakeholder',
            },
          },
        ],
      },
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Stakeholder ID',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  value: {
                    '++': [
                      'STK-',
                      {
                        '+': [
                          {
                            '#': {
                              '@': 'existingStakeholders',
                            },
                          },
                          1,
                        ],
                      },
                    ],
                  },
                  readonly: true,
                },
              },
              {
                '{}': {
                  id: 'stakeholderName',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'jobTitleRole',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!personnel#!employee:!job_title',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'subdepartmentTeam',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!personnel#!employee:!org',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'managerLeader',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!personnel_leaders#!relationship:!leader',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'projectTeam',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!is_project_team_member',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'projectRole',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!project_role',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'systemUserRole',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'System / User Role',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'degreeOfImpact',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!degree_of_impact',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'influenceDecisionRole',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!influence_decision_role',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'changeChampion',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!change_champion',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'engagementNeeded',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!engagement_needed',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'validationStatus',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!validation_status',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'understanding',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!understanding',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'perceivedAttitude',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!perceived_attitude',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'potentialConcernsRisks',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!concerns_risks',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'supportNeeds',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!support_needs',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'communicationAudience',
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Communication Audience / Group',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'trainingAudienceNeed',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!training_audience_need',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'notesFollowUp',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!stakeholders#!stakeholder:!notes_follow_up',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'save.stakeholder',
                },
              },
              variables: {
                '{}': {
                  employeeName: '${field:stakeholderName}',
                  stakeholderId: '${field:code}',
                  managerEmployee: '${field:managerLeader}',
                  stakeholderCode: '${field:code}',
                  stakeholderName: '${field:stakeholderName}',
                  employeeJobTitle: '${field:jobTitleRole}',
                  employeeOrganization: '${field:subdepartmentTeam}',
                  stakeholderProjectRole: '${field:projectRole}',
                  stakeholderProjectTeam: '${field:projectTeam}',
                  stakeholderSupportNeeds: '${field:supportNeeds}',
                  stakeholderNotesFollowUp: '${field:notesFollowUp}',
                  stakeholderUnderstanding: '${field:understanding}',
                  stakeholderChangeChampion: '${field:changeChampion}',
                  stakeholderDegreeOfImpact: '${field:degreeOfImpact}',
                  stakeholderSystemUserRole: '${field:systemUserRole}',
                  stakeholderEngagementNeeded: '${field:engagementNeeded}',
                  stakeholderValidationStatus: '${field:validationStatus}',
                  stakeholderPerceivedAttitude: '${field:perceivedAttitude}',
                  stakeholderTrainingAudienceNeed:
                    '${field:trainingAudienceNeed}',
                  stakeholderCommunicationAudience:
                    '${field:communicationAudience}',
                  stakeholderInfluenceDecisionRole:
                    '${field:influenceDecisionRole}',
                  stakeholderPotentialConcernsRisks:
                    '${field:potentialConcernsRisks}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    existingStakeholders: {
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
